import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a621fa24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-count-wrap" }
const _hoisted_2 = { class: "total-count" }
const _hoisted_3 = { class: "total-count-value" }
const _hoisted_4 = { class: "total-count-label" }
const _hoisted_5 = { class: "legend-list" }
const _hoisted_6 = { class: "legend-name" }
const _hoisted_7 = { class: "legend-value" }

import * as echarts from 'echarts'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ResizeService } from '@/services/resize.service'
import { getColorDefault, getTooltipFormatter } from '@/utils/echarts-option/base'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import { computed, onMounted, onUnmounted, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  TeamTerminalInfo
} from '@/views/dashboard/cascade-center/branch-overview/_components/team-info/team-info.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-count',
  props: {
  teamInfo: {
    type: {} as PropType<TeamTerminalInfo>,
    default: () => ({} as TeamTerminalInfo)
  },
},
  setup(__props) {

const props = __props

const { t, locale } = useI18n()

const injector = useReflectiveInjector([])
const resizeService = injector.get(ResizeService)

const chartNode = ref<Node & HTMLElement>()
let chartInstance: echarts.EChartsType

const chartColors = computed(() => getColorDefault())

const chartData = computed(() => {
  void locale.value
  return [
    {
      name: t('cascadeBranchOverview.terminalOsWindows'),
      value: props.teamInfo.windows_num || 0,
    },
    {
      name: t('cascadeBranchOverview.terminalOsLinux'),
      value: props.teamInfo.linux_num || 0,
    },
    {
      name: t('cascadeBranchOverview.terminalOsServer'),
      value: props.teamInfo.windows_server_num || 0,
    },
  ]
})

function initChart() {
  chartInstance && chartInstance.dispose()
  createChart()
  renderChart()
}

function createChart() {
  if (!chartNode.value) {
    return
  }
  chartInstance = echarts.init(chartNode.value, null)
}

function renderChart() {
  if (!chartInstance) {
    return
  }

  chartInstance.setOption(getChartOption())
}

function getChartOption() {
  const option = {
    tooltip: {
      formatter: (params) => getTooltipFormatter(params, {}),
    },
    series: [
      {
        name: t('cascadeBranchOverview.terminalCountPieSeriesName'),
        data: getSeriesData(),
        radius: ['46%', '72%'],
        center: ['50%', '46%'],
      },
    ],
  }

  return getAssignPieOption(option)
}

function getSeriesData() {
  return chartData.value.map(v => ({
    ...v,
    label: { show: false }
  }))
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

useEchartsThemeSync(() => {
  if (chartInstance) renderChart()
})

onMounted(() => {
  initChart()
})

onUnmounted(() => {
  chartInstance && chartInstance.dispose()
  resizeSubscribe.unsubscribe()
})

watch(() => props.teamInfo?.team_id, () => {
  initChart()
})

watch(chartData, () => {
  if (chartInstance) {
    renderChart()
  }
}, { deep: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "chartNode",
      ref: chartNode,
      class: "chart-wrap"
    }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.teamInfo.total || 0), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('cascadeBranchOverview.terminalCountCenterLabel')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chartData.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "legend-item",
          key: index
        }, [
          _createElementVNode("div", {
            class: "legend-marker",
            style: _normalizeStyle({ backgroundColor: chartColors.value[index] })
          }, null, 4),
          _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.value), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})